export default __webpack_public_path__ + "static/media/aanchal-testimonial.97aa18d8.png";